import React, { useLayoutEffect, useRef } from 'react'
import { appliancepb } from 'src/services/protobuf-models/appliance-ms-protobuf-models'
import { isCurrentRangeDate } from '../helpers'
import {
  Notification,
  IconProhibitionFull,
  IconInfoFull,
  IconWarningTriangleFull,
} from '@ftdr/blueprint-components-react'
import { getStatus } from '../helpers'

const AlertBanner: React.FC<appliancepb.IBanner> = ({
  activate,
  expire,
  id,
  severity,
  message,
}: appliancepb.IBanner) => {
  const ref = useRef<HTMLDivElement>(null)
  const getIcon = (
    severity: appliancepb.Banner.Severity | null | undefined
  ) => {
    switch (severity) {
      case appliancepb.Banner.Severity['SEVERITY_INFO']:
        return (
          <IconInfoFull size="22" className="message-icon-info flex-shrink-0" />
        )

      case appliancepb.Banner.Severity['SEVERITY_CAUTION']:
        return (
          <IconProhibitionFull
            size="22"
            className="message-icon-error flex-shrink-0"
          />
        )
      case appliancepb.Banner.Severity['SEVERITY_WARNING']:
        return (
          <IconWarningTriangleFull
            size="22"
            className="message-icon-warning flex-shrink-0"
          />
        )
      default:
        return null
    }
  }

  useLayoutEffect(() => {
    if (!ref?.current) return
    const parent = ref.current.closest('.message')
    const icon = parent?.firstElementChild
    icon?.remove()
  }, [])

  return isCurrentRangeDate(
    new Date((activate?.seconds! * 1000) as number).getTime(),
    new Date((expire?.seconds! * 1000) as number).getTime()
  ) ? (
    <Notification
      id={`${id}-alert-notification`}
      key={id}
      showStatusLabel={false}
      status={getStatus(severity!)}
    >
      <div className="m-auto container" ref={ref}>
        <div className="max-w-md sm:max-w-full m-auto flex gap-2">
          {getIcon(severity)}
          <p>{message as string}</p>
        </div>
      </div>
    </Notification>
  ) : null
}

export default AlertBanner
